import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';

import { FetchEmployees } from '../teamleader.actions';
import { TeamleaderState } from '../teamleader.state';

@Component({
    selector: 'app-teamleader-employees',
    templateUrl: './teamleader-employees.component.html',
    styleUrls: ['./teamleader-employees.component.scss'],
})
export class TeamleaderEmployeesComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    @Select(TeamleaderState.employees) teamleaderUsers$: Observable<any[]>;
    filter: string;
    isLoading = true;
    isset: boolean;

    constructor(private store: Store) {}

    ngOnInit(): void {}

    checkCredentials(set: boolean) {
        this.isset = set;
        if (this.isset) {
            this.subscriptions.add(
                this.store.dispatch(new FetchEmployees()).subscribe(() => {
                    this.isLoading = false;
                }),
            );
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
